module.exports = __webpack_public_path__ + "assets/images/views/intro_window_frame_discl2.png";